import { useLocation } from 'react-router'
import { isCartExcludedPath } from '../../../features/cart/cart.consts'
import ChatSupportButton from './ChatSupportButton'
import CartBagButton from './CartBagButton'

export default function DefaultTopBarRightButton({
  color,
  source,
}: {
  color?: string
  source?: string
}) {
  const { pathname } = useLocation()

  const showBag = !isCartExcludedPath(pathname)

  return showBag ? (
    <CartBagButton color={color} />
  ) : (
    <ChatSupportButton color={color} source={source} />
  )
}
